import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/apple_app_store.svg")